import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";

@Component({
  selector: "dropdown",
  templateUrl: "./dropdown.component.html",
})
export class DropdownComponent implements OnChanges {
  @Input() optionList: any[];
  @Input() placeholder: string;
  @Input() selectProperty: string;
  @Input() shouldResetSelectedValue: boolean;
  @Output() select = new EventEmitter();
  selectedOption: string;

  constructor() {}

  ngOnChanges(changes: any) {
    if (
      changes.optionList &&
      changes.optionList.currentValue &&
      this.selectProperty === "doctorId"
    ) {
      this.selectedOption = this.optionList[0].name;
    }
    if (
      changes &&
      changes.shouldResetSelectedValue &&
      changes.shouldResetSelectedValue.currentValue
    ) {
      this.selectedOption = null;
    }
  }

  selectOption(option: any) {
    switch (this.selectProperty) {
      case "uid":
        this.selectedOption = option.name;
        this.select.next(option.uid);
        break;
      case "doctorId":
        this.selectedOption = option.name;
        this.select.next(option.doctorId);
        break;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/components/dropdown/dropdown.component.ts